import React from 'react';

interface ToggleProps {
  active: boolean;
  onClick: () => void;
  color?: string;
}

export const Toggle: React.FC<ToggleProps> = ({ active, onClick, color = 'bg-blue-500' }) => (
  <button 
    onClick={onClick} 
    className={`w-10 h-5 rounded-full relative transition-all shadow-inner ${active ? color : 'bg-neutral-400'}`}
  >
    <div className={`absolute w-4 h-4 bg-white rounded-full shadow top-0.5 left-0.5 transition-all ${active ? 'translate-x-5' : ''}`} />
  </button>
);